<div class="header-instructions">
  <div class="header-wrapper">
    @if (editHeaderOptions()) {
    <div class="buttons-wrapper">
      <button class="mat-icon-button bg-white-button" data-qa="hide-header-icon-button" disableRipple="true" mat-button
        [class.disabled-button]="isPromptHeader()" [class.icon-selected]="isHideHeader()"
        (click)="this.hideHeaderOrInstructions(true)">
        <i [class]="!isHideHeader() ? 'fa-regular fa-eye-slash' : 'fa-regular fa-eye'"></i>
      </button>
      @if(!isAlwaysEditable()) {
      <button class="mat-icon-button bg-white-button" data-qa="edit-header-icon-button" disableRipple="true" mat-button
        [class.icon-selected]="isEditHeader()" [class.disabled-button]="isHideHeader()"
        (click)="onSelectPromptMenu(0)">
        <i class="fa-regular fa-pen-to-square"></i>
      </button>
      }
    </div>
    }
    @if(showHeader()) {
      @if (editHeaderOptions()) {
        <textarea #headerInput aria-label="Prompt Header" autocomplete="off" cdkTextareaAutosize class="header" cols="1"
                  data-qa="prompt-header-textarea" id="prompt-header" maxlength="255" matInput cdkAutosizeMinRows="1" cdkAutosizeMaxRows="8"
                  [class.readonly-input]="!editHeaderOptions()" [class.readonly-header]="!editHeaderOptions()" [class.edit-mode]="editHeaderOptions()" [class.instructions-disabled]="isHideHeader()" [class.component-header]="!isPromptHeader()"
                  [placeholder]="hasHeaderPlaceHolder ? (headerPlaceHolderValue() ?? '') : (isPromptHeader() ? 'Please write your Prompt header here.' : 'Please write your Prompt Component header here.')"
                  [readonly]="!isEditHeader()" [(ngModel)]="promptHeader" (focusout)="onFocusOutInput()"
                  (ngModelChange)="onInputChange()">
        </textarea>
      } @else {
        @if (promptHeader) {
          <div class="display header" [class.prompt-header]="isPromptHeader()">
            {{ promptHeader }}
          </div>
        } @else {
          <div class="display-placeholder header">
            @if (isPromptHeader()) {
              Please write your Prompt header here.
            } @else {
              {{ headerPlaceHolderValue() ?? '' }}
            }
          </div>
        }
      }
    }
  </div>
  <div class="instructions-wrapper">
    @if (editHeaderOptions()) {
    <div class="buttons-wrapper">
      <button class="mat-icon-button bg-white-button" data-qa="hide-instructions-icon-button" disableRipple="true"
        mat-button [class.icon-selected]="isHideInstructions()" (click)="hideHeaderOrInstructions()">
        <i [class]="!isHideInstructions() ? 'fa-regular fa-eye-slash' : 'fa-regular fa-eye'"></i>
      </button>
      @if(!isAlwaysEditable()) {
      <button class="mat-icon-button bg-white-button" data-qa="edit-instructions-icon-button" disableRipple="true"
        mat-button [class.disabled-button]="isHideInstructions()" [class.icon-selected]="isEditInstructions()"
        (click)="onSelectPromptMenu()">
        <i class="fa-regular fa-pen-to-square"></i>
      </button>
      }
    </div>
    }
    @if(showInstructions()) {
      @if (editHeaderOptions()) {
        <textarea #instructionsInput aria-label="Prompt Instructions" autocomplete="off" cdkTextareaAutosize
                  cdkAutosizeMinRows="1" cdkAutosizeMaxRows="8" class="instructions" cols="1" 
                  data-qa="prompt-instructions-textarea" id="prompt-instructions" matInput maxlength="1000"
                  [class.readonly-input]="!editHeaderOptions()" [class.readonly-instructions]="!editHeaderOptions()"
                  [class.edit-mode]="editHeaderOptions()" [class.instructions-disabled]="isHideInstructions()"
                  [placeholder]="hasInstructionPlaceHolder ? (instructionPlaceHolderValue() ?? '') : (isPromptHeader() ? 'Please write instructions for prompt here.' : 'Please give instructions for Prompt Component here.')"
                  [readonly]="!isEditInstructions()" [(ngModel)]="promptInstructions" (focusout)="onFocusOutInput()"
                  (ngModelChange)="onInputChange()">
        </textarea>
       } @else {
        @if (promptInstructions) {
          <div class="display instructions" [class]="{ 'instructions-disabled': isHideInstructions(), 'prompt-instructions': isPromptHeader()}">
            {{ promptInstructions }}
          </div>
        } @else {
          <div class="display-placeholder instructions" [class.prompt-instructions]="isPromptHeader()">
            @if (isPromptHeader()) {
              Please write instructions for Prompt here.
            } @else {
              {{ instructionPlaceHolderValue() ?? '' }}
            }
          </div>
        }
      }
    }
  </div>
</div>